// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.equipmentDetails__EQ_KM {
  background-color: var(--tables-title-surface);
}

.equipmentDetailsBody__TCC0J {
  width: 100%;
  min-height: calc(100vh - 105px);
  padding: 25px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: auto 1fr;
  gap: 25px;
  background-color: var(--tables-main-surface);
}
@media (max-width: 1300px) {
  .equipmentDetailsBody__TCC0J {
    height: auto;
    display: flex;
    flex-direction: column;
  }
}
@media (max-width: 850px) {
  .equipmentDetailsBody__TCC0J {
    padding: 15px;
    row-gap: 15px;
  }
}

.associatedBlock__LiZQs {
  grid-area: 2/1/2/3;
  height: 100%;
  padding: 1px;
}

.extraInfoWrapper__gG6Jb {
  font-size: 11px;
  line-height: 12px;
  color: var(--header-title-secondary);
  text-transform: uppercase;
}

.extraInfo__CeLAY {
  font-weight: 600;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/EquipmentDetails/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,6CAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,4BAAA;EACA,SAAA;EACA,4CAAA;AAzEF;AA2EE;EAVF;IAWI,YAAA;IACA,aAAA;IACA,sBAAA;EAxEF;AACF;AA0EE;EAhBF;IAiBI,aAAA;IACA,aAAA;EAvEF;AACF;;AA0EA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AAvEF;;AA0EA;EACE,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;AAvEF;;AA0EA;EACE,gBAAA;EACA,gBAAA;AAvEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.equipmentDetails {\n  background-color: var(--tables-title-surface);\n}\n\n.equipmentDetailsBody {\n  width: 100%;\n  min-height: calc(100vh - 105px);\n  padding: 25px;\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  grid-template-rows: auto 1fr;\n  gap: 25px;\n  background-color: var(--tables-main-surface);\n\n  @media (max-width: 1300px) {\n    height: auto;\n    display: flex;\n    flex-direction: column;\n  }\n\n  @media (max-width: 850px) {\n    padding: 15px;\n    row-gap: 15px;\n  }\n}\n\n.associatedBlock {\n  grid-area: 2/1/2/3;\n  height: 100%;\n  padding: 1px;\n}\n\n.extraInfoWrapper {\n  font-size: 11px;\n  line-height: 12px;\n  color: var(--header-title-secondary);\n  text-transform: uppercase;\n}\n\n.extraInfo {\n  font-weight: 600;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"equipmentDetails": `equipmentDetails__EQ_KM`,
	"equipmentDetailsBody": `equipmentDetailsBody__TCC0J`,
	"associatedBlock": `associatedBlock__LiZQs`,
	"extraInfoWrapper": `extraInfoWrapper__gG6Jb`,
	"extraInfo": `extraInfo__CeLAY`
};
module.exports = ___CSS_LOADER_EXPORT___;
